import * as types from './mutation-types'

export const updateConfig = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/'+ data.id +'/configuration', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadAccessStatus = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/access/status', data).then((response) => {
            commit(types.LOAD_ACCESS_STATUS, response.data)
        }).catch((err) => {
            reject(err)
        })
    })
}